export default (str) => str.toUpperCase();
